import { render } from "./Button-text-border.vue?vue&type=template&id=2560fc52&scoped=true"
import script from "./Button-text-border.vue?vue&type=script&lang=js"
export * from "./Button-text-border.vue?vue&type=script&lang=js"

import "./Button-text-border.vue?vue&type=style&index=0&id=2560fc52&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2560fc52"]])

export default __exports__